module.exports = __webpack_public_path__ + "media/MyAudio_3.1d2c904e.mp3";